import { render, staticRenderFns } from "./SparePartCategoryDetail.vue?vue&type=template&id=48dd0add&scoped=true&"
import script from "./SparePartCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./SparePartCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./SparePartCategoryDetail.vue?vue&type=style&index=0&id=48dd0add&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd0add",
  null
  
)

export default component.exports